import React from "react"
import starIcon from "../../images/star-icon.png"
import DynamicImage from "../common/DynamicImage";
import { HighlightText } from "../common/HighlightText";

const ContactUsContent = ({ data }) => {

  return (
    <>
      <section className="about-area ptb-70">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-6 col-md-12" data-aos="slide-right" data-aos-duration="1200">
              <div className="about-content">
                <div className="content">
                  <span className="sub-title">
                    <img src={starIcon} alt="banner" />
                    {data?.subheading}
                  </span>
                  <h2><HighlightText content={data?.heading} /></h2>
                  {data?.descriptions?.map((block, index) => {
                    if (block.type === "paragraph") {
                      return (
                        <p key={index}>
                          <HighlightText content={block.children.map((child) => child.text).join("")} />
                        </p>
                      );
                    }
                    return null;
                  })}


                </div>
              </div>
            </div>
            <div className="col-lg-6 col-md-12" data-aos="slide-left" data-aos-duration="1200">
              <div className="about-image">
                <DynamicImage image={data?.heroImage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ContactUsContent
